import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Waypoint } from 'react-waypoint'
import clsx from 'clsx'

const styles = theme => ({
    root: {
        height: props => `${props.height || 'auto'}`,
        width: props => props.width || 'auto',
        opacity: '0',
        transition: props => `opacity ${props.seconds || 2}s cubic-bezier(.4,.28,0,1.03)`
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center !important',
        alignItems: "center"
    },
    columnCenter: {
        display: 'flex',
        justifyContent: 'center !important',
        alignItems: "center",
        flexDirection: 'column'
    },
    fadeIn: {
        opacity: '1 !important'
    }
})

const useStyles = makeStyles(styles)

export default function FadeInHOC({ children, seconds, width, height, rootClass, centerFlex, id, div, columnCenter }) {
    const [faded, setFaded] = useState(false)
    function fadeIn() {
        setFaded(true)
    }
    const props = { seconds, width, height }
    const classes = useStyles(props)
    return (
        <Waypoint
            onEnter={fadeIn}
        >
            {div ?
                <div
                    id={id || 'page'}
                    className={clsx(!rootClass && classes.root, columnCenter && classes.columnCenter, rootClass && rootClass, faded && classes.fadeIn, centerFlex && classes.flexCenter)} >
                    {children}
                </div> :
                <span
                    id={id || 'page'}
                    className={clsx(!rootClass && classes.root, columnCenter && classes.columnCenter, rootClass && rootClass, faded && classes.fadeIn, centerFlex && classes.flexCenter)} >
                    {children}
                </span>
            }
        </Waypoint>
    )
}